import { useContext } from "react"
import { PtSiteCtx } from "./CustomSiteF/CustomSiteWrapperF"
import { Center } from "@chakra-ui/react"
import * as _ from 'lodash-es'

/**
 * @typedef {object} ErrLoadingWrapProps
 * @property {import('@apollo/client').ApolloError} [error]
 * @property {boolean} [loading]
 * @property {unknown} [data]
 * @property {import('react').ReactNode} [children]
 */

export const ErrLoadingWrap = (/** @type {ErrLoadingWrapProps & Record<string, any>} */ {error, loading, children, ...props}) => {
  const data = _.has(props, 'data') ? props.data : true
  delete props.data

  const {fmtSiteError, LoadingComp, ErrComp=Center} = useContext(PtSiteCtx)
  if (error) {
    console.log(error)
    return <ErrComp {...{...props}}>{fmtSiteError({error})}</ErrComp>
  }
  if (loading || !data) return <LoadingComp {...props} />
  return children
}
